import React, { useEffect, useState } from 'react';
import { UsersIcon } from 'lucide-react';
export function LiveVisitorCounter() {
  const [visitorCount, setVisitorCount] = useState(0);
  useEffect(() => {
    // Generate a random number between 200 and 250 for initial count
    const initialCount = Math.floor(Math.random() * (250 - 200 + 1)) + 200;
    setVisitorCount(initialCount);
    // Set up interval to randomly fluctuate the visitor count
    const intervalId = setInterval(() => {
      // Randomly decide whether to increase or decrease
      const change = Math.random() > 0.5 ? 1 : -1;
      // Apply the change but keep within reasonable bounds
      setVisitorCount(prevCount => {
        const newCount = prevCount + change;
        if (newCount < 200) return 200; // Don't go below 200
        if (newCount > 250) return 249; // Don't go above 250
        return newCount;
      });
    }, 3000); // Update every 3 seconds
    return () => clearInterval(intervalId);
  }, []);
  return <div className="fixed bottom-4 left-4 bg-white shadow-md rounded-full py-2 px-4 flex items-center text-sm font-medium text-gray-800 border border-gray-200 z-40" data-id="element-244">
      <UsersIcon className="h-4 w-4 text-blue-600 mr-2" data-id="element-245" />
      <span data-id="element-246">{visitorCount} Watching Now</span>
    </div>;
}